import axios from 'axios';
import { API } from '../global/global';
import { DispositivoInterface } from '../interfaces/DispositivoInterface';

export interface UbicacionOnAsset {
  dispositivo_id: number;
  nombre_dispositivo: string;
  sentinel_id: string;
  friendly_name: string;
  latitude: number;
  longitude: number;
  timeOfReport: string;
  timeOfReceipt?: string;
  timeOfSighting?: string;
  temperatureC?: number;
  temperatureF?: number;
  batteryPercent?: number;
  batteryVoltage?: number;
  humidity?: number;
  light?: number;
  rssi?: number;
  beaconType?: string;
  sentinelType?: string;
  marca: string;
  modelo: string;
  imei: string;
  numero_serie: string;
  estatus_dispositivo: string;
  tiempo_desde_reporte: string;
  reportId?: string;
  sightingId?: string;
}

export const getDispositivos = async (token: string): Promise<DispositivoInterface[]> => {
  try {
    const response = await axios.get(`${API}/dispositivos`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('🔍 Respuesta de dispositivos:', response.data);
    
    // Asegurar que siempre devolvemos un array
    const data = response.data.data || response.data;
    
    if (Array.isArray(data)) {
      return data;
    } else if (data && typeof data === 'object') {
      // Si es un objeto, podría tener una propiedad que contenga el array
      const possibleArrays = Object.values(data).filter(Array.isArray);
      if (possibleArrays.length > 0) {
        return possibleArrays[0] as DispositivoInterface[];
      }
    }
    
    // Si no encontramos un array, devolver array vacío
    console.warn('⚠️ No se encontró array de dispositivos, devolviendo array vacío');
    return [];
    
  } catch (error) {
    console.error('❌ Error al obtener dispositivos:', error);
    throw error;
  }
};

export const getDispositivoById = async (id: number, token: string): Promise<DispositivoInterface> => {
  const response = await axios.get(`${API}/dispositivos/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data || response.data;
};

export const createDispositivo = async (dispositivo: Partial<DispositivoInterface>, token: string): Promise<DispositivoInterface> => {
  const response = await axios.post(`${API}/dispositivos`, dispositivo, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data || response.data;
};

export const updateDispositivo = async (id: number, dispositivo: Partial<DispositivoInterface>, token: string): Promise<DispositivoInterface> => {
  const response = await axios.put(`${API}/dispositivos/${id}`, dispositivo, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data || response.data;
};

export const deleteDispositivo = async (id: number, token: string): Promise<void> => {
  await axios.delete(`${API}/dispositivos/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getTagsDisponibles = async (token: string): Promise<any[]> => {
  try {
    const response = await axios.get(`${API}/dispositivos/tags-disponibles`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('🏷️ Tags disponibles:', response.data);
    return response.data.data || [];
    
  } catch (error) {
    console.error('❌ Error al obtener tags disponibles:', error);
    throw error;
  }
};

export const getUbicacionesOnAsset = async (token: string): Promise<UbicacionOnAsset[]> => {
  try {
    // Primero intentar con datos reales
    let response = await axios.get(`${API}/dispositivos/ubicaciones-onasset`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('📍 Ubicaciones OnAsset (reales):', response.data);
    
    // Si no hay datos reales, usar simulados
    if (!response.data.data || response.data.data.length === 0) {
      console.log('⚠️ No hay datos reales, usando simulados...');
      response = await axios.get(`${API}/dispositivos/ubicaciones-simuladas`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      console.log('📍 Ubicaciones OnAsset (simuladas):', response.data);
    }
    
    return response.data.data || [];
    
  } catch (error) {
    console.error('❌ Error al obtener ubicaciones OnAsset:', error);
    
    // Como fallback, intentar ubicaciones simuladas
    try {
      console.log('🔄 Intentando ubicaciones simuladas como fallback...');
      const fallbackResponse = await axios.get(`${API}/dispositivos/ubicaciones-simuladas`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      console.log('📍 Ubicaciones simuladas (fallback):', fallbackResponse.data);
      return fallbackResponse.data.data || [];
    } catch (fallbackError) {
      console.error('❌ Error también en ubicaciones simuladas:', fallbackError);
      throw error;
    }
  }
};
